import { render, staticRenderFns } from "./BalanceHelp.vue?vue&type=template&id=0eddcfc0"
import script from "./BalanceHelp.vue?vue&type=script&lang=js"
export * from "./BalanceHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports